module.exports = __webpack_public_path__ + "static/media/iso.dbc93c05.svg";